import React from "react";
import { Link } from "react-router-dom";

const ServiceCard = ({ service }) => (
    <div className="group flex flex-col h-full bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-lg transition-all duration-300">
      <div className="h-40 overflow-hidden">
        <img
          src={service.image}
          alt={service.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
  
      <div className="p-5 flex flex-col flex-grow">
        <h3 className="text-xl font-semibold text-[#2C3E50] mb-3">
          {service.title}
        </h3>
  
        <p className="text-gray-600 mb-6 flex-grow">
          {service.description}
        </p>
  
        <Link
          to={service.link}
          className="inline-flex items-center text-[#C5A047] font-medium hover:text-[#D4AF37] transition-colors"
        >
          Learn More
          <svg
            className="ml-2 w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M14 5l7 7m0 0l-7 7m7-7H3"
            />
          </svg>
        </Link>
      </div>
    </div>
  );

export default ServiceCard;